const TEST_IDS = {
  tokenTextField: 'vault-transaction-form-token-text-field',
  availableTokens: 'vault-transaction-form-available-tokens',
  lockingPeriod: 'vault-transaction-form-locking-period',
};

export default TEST_IDS;
